import React from 'react'

const Section2 = () => {
    return (
        <>
            {/* <!--活動二 第五劇本殺 --> */}
        <section id="event_02" className="event_02 wow fadeInUp">
            <img src="/events/img/top_dark.png" alt="" />
            <div className="inner_wrap">
                <h2>第五劇本殺 直播燒腦對決</h2>
                <span>活動時間 7/4 20:00-22:00</span>
                <img src="/events/img/line.png" alt="" className="line" />
                <div className="event_tip">
                    <p>
                        《第五人格》 三週年狂歡特別企劃，邀請劇本殺高玩陳零九&amp;黃偉晉與知名遊戲實況主們，進行一場由 《第五人格》 世界觀改編的線上劇本殺直播活動。精彩入勝的角色演繹，緊張刺激的邏輯推理，邀請偵探們一起推敲線索、找出誰是真兇！
                        <br/><br/>
                        本次直播採多頻道、多視角轉播，除了官方主頻道會有主要節目視角外，在各個實況主頻道也會同步進行直播。
                        偵探們可在各個實況台間，嘗試找出關鍵線索！
                        <br/><br/>
                        官方主頻道更有豐厚的高階虛寶及推理獎勵等著大家。
                        經過調查與推敲，最終正確答出真凶是誰的偵探，更有機會獲得「首席偵探贈禮」周邊大禮包獎勵。
                    </p>
                </div>
                <img src="/events/img/line.png" alt="" className="line" />
            </div>
        </section>
        </>
    )
}

export default Section2